<!--
 * @Description: 运维监测
 * @Author: ChangWenBo (649160016@qq.com)
 * @Date: 2021-03-16 14:20:28
 * @LastEditors: ChangWenBo (649160016@qq.com)
 * @LastEditTime: 2021-03-25 15:26:04
 -->
<template>
  <div class="maintenance-service">
    <el-button size="small" class="btn" @click="exportClick"
      >导出数据</el-button
    >
    <div class="topContainer">
      <Top />
    </div>
    <div class="bottomContainer">
      <div class="bottom-left">
        <BottomLeft />
      </div>
      <div class="bottom-center">
        <BottomCenter />
      </div>
      <div class="bottom-right">
        <BottomRight />
      </div>
    </div>
  </div>
</template>

<script>
import Top from "./components/top";
import BottomLeft from "./components/bottomLeft";
import BottomCenter from "./components/bottomCenter";
import BottomRight from "./components/bottomRight";
export default {
  name: "maintenanceService",
  components: {
    Top,
    BottomLeft,
    BottomCenter,
    BottomRight
  },
  data() {
    return {};
  },
  methods: {
    exportClick() {
      let a = document.createElement("a")
      a.href = '/rest/screen/jdyw/excel'
      a.click()
      a = null
    }
  },
  created() {}
};
</script>

<style lang="less" scoped>
.maintenance-service {
  .btn {
    position: absolute;
    right: 40px;
    top: 60px;
    background-color: #22bbbe;
    border-color: #22bbbe;
    color: #fff;
    &:active {
      background-color: #27dde0;
    }
  }
  width: 90%;
  height: calc(100% - 10vh);
  margin: 0 5%;
  padding: 5vh 0;
  .topContainer {
    width: 100%;
    height: 10%;
  }
  .bottomContainer {
    width: 100%;
    height: 90%;
    display: flex;
    justify-content: space-between;
    > div {
      display: inline-block;
    }
    .bottom-left {
      width: 28%;
      height: 100%;
    }
    .bottom-center {
      width: calc(44% - 2vh);
      height: calc(100% - 6vh);
      padding: 3vh 1vh;
      display: flex;
      justify-content: space-around;
    }
    .bottom-right {
      width: 28%;
      height: 100%;
    }
  }
}
</style>
